import { DefaultPrimaryHeader, DescriptionSecondary, HeaderBlock } from '../activityFeedHeaderShared';

function OrgSettingsUpdatedHeader({ item, activity }) {
  return (
    <HeaderBlock
      primary={<DefaultPrimaryHeader label="Organization settings" activity={activity} />}
      secondary={<DescriptionSecondary item={item} />}
    />
  );
}

export default OrgSettingsUpdatedHeader;
